/** @format */

import { AfterViewInit, Component, DestroyRef, PLATFORM_ID, inject, input } from '@angular/core';
import {
	ProductReviewAnalyticsService,
	ProductReviewDrawerType,
	openProductReviewDrawer,
	selectProductReviewCount
} from '@product-reviews/data-access';

import { Store } from '@ngrx/store';
import { isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'product-reviews-rating-summary-stars-v2',
	templateUrl: './review-rating-summary-stars.component.html',
	styleUrls: ['./review-rating-summary-stars.component.scss'],
	standalone: false
})
export class ReviewRatingSummaryStarsComponent implements AfterViewInit {
	private readonly platformId = inject(PLATFORM_ID);
	private readonly analyticsService = inject(ProductReviewAnalyticsService);
	private readonly store = inject(Store);
	private readonly destroyRef = inject(DestroyRef);
	protected readonly isPlatformBrowser = isPlatformBrowser(this.platformId);

	productPartNumber = input.required<string>();
	isDrawerAvailable = input<boolean>();
	reviewCount = 0;
	reviewCount$ = this.store.select(selectProductReviewCount);

	ngAfterViewInit(): void {
		if (this.isPlatformBrowser) {
			// Keep BV from scrolling to highlight container when we open drawer (they call scroll into view on their side)
			this.reviewCount$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((reviewCount) => {
				this.reviewCount = reviewCount;
				if (this.isDrawerAvailable() && reviewCount) {
					const highlightElement = document?.getElementById(
						'product-reviews-highlight-container'
					);
					if (highlightElement) {
						// eslint-disable-next-line @typescript-eslint/no-empty-function
						highlightElement.scrollIntoView = () => {};
					}
				}
			});
		}
	}

	public handleClick() {
		this.trackReviewSummaryClicked();

		if (this.isDrawerAvailable() && this.reviewCount) {
			this.openReviewsDrawer();
		}
	}

	openReviewsDrawer() {
		const contentListDrawer = { drawerType: ProductReviewDrawerType.REVIEWS };
		this.store.dispatch(openProductReviewDrawer(contentListDrawer));
	}

	private trackReviewSummaryClicked() {
		const payload = {
			event: 'ReviewSummaryClicked',
			value: 'Summary'
		};

		this.analyticsService.fireReviewAnalytics<{ [key: string]: string }>({
			name: 'multiUseAnalyticsEvent',
			payload
		});
	}
}
